import {axios} from '../Api';

class PresetsService {
    getPresets = async () => {
        const result = await axios.get('/app/api/preset');
        return result.data;
    };

    persistPreset = async (data) => {
        const {id} = data;
        const url = '/app/api/preset';
        const result = (id) ? await axios.put(url, data) : await axios.post(url, data);
        return result.data;
    };

    deletePreset = (id) => {
        return axios.delete(`/app/api/preset/${id}`);
    };

    setPreferredPreset = (id, amplitude, spread) => {
        return axios.put(`/app/api/image/${id}/updatePreferredParams?amplitude=${amplitude}&spread=${spread}`);
    };

    setUserPreferredPreset = (amplitude, spread) => {
        return axios.put(`/app/api/user/updatePreferredParams?amplitude=${amplitude}&spread=${spread}`);
    };
}

export default new PresetsService();



// WEBPACK FOOTER //
// ./src/services/PresetsService.js